import { useState } from 'react'
import RTruncate from 'react-truncate'

function Truncate({ text, lines, className }: { text?: string; lines?: number; className?: string }) {
  if (!text) return null
  const numLines = lines || 3
  const [showFull, setshowFull] = useState<boolean>(false)
  const [showMore, setShowMore] = useState<boolean>(false)

  return (
    <div className={className}>
      <RTruncate
        lines={showFull ? false : numLines}
        ellipsis={
          <span>
            ...{' '}
            <button className='text-wisteria' onClick={() => setshowFull(true)}>
              show more
            </button>
          </span>
        }
        onTruncate={(isTruncated) => {
          if (!showMore && isTruncated) setShowMore(true)
        }}
      >
        <span dangerouslySetInnerHTML={{ __html: text.replace(/\n/, '<br/>') }} />

        {showMore && (
          <span>
            ...{' '}
            <button className='text-wisteria' onClick={() => setshowFull(false)}>
              show less
            </button>
          </span>
        )}
      </RTruncate>
    </div>
  )
}

export default Truncate
